<script>
import { file } from "@/mixins/file";
export default {
  mixins: [file],
};
</script>

<script setup>
import ShareModal from "@/components/ShareModal.vue";
import { useMessage } from "@/composables/useMessage";
import axios from "@/plugins/axios";
import { DateFormatter } from "@/utils/basics/date";
import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonPage,
  IonRadio,
  IonRadioGroup,
  IonTextarea,
  IonTitle,
  IonToolbar,
  modalController,
  onIonViewDidEnter,
  IonRow,
  IonCol,
} from "@ionic/vue";
import {
  arrowDownCircleOutline,
  sendOutline,
  close,
  attach,
  trashOutline,
} from "ionicons/icons";
import { computed, nextTick, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import PrivacyPersonalData from "@/components/PrivacyPersonalData.vue";
import EndModal from "@/components/EndModal.vue";
import { apiSendMessageToPartner } from "@/api/message";
import BefundeAuswahlModal from "@/components/BefundeAuswahlModal.vue";
import { apiGetCases } from "@/api/user";

const store = useStore();
const route = useRoute();

const costEstimateQuestion =
  "Entspricht der Kostenvoranschlag Ihren Vorstellungen?";
const messages = computed(() => {
  const result = [];
  const foundConversation = store.state.conversations.find(
    (obj) => obj.caseId === route.params.caseId
  );
  if (foundConversation && foundConversation.messages) {
    for (const [
      messageIndex,
      message,
    ] of foundConversation.messages.entries()) {
      if (message.FromUser && message.Type === "costEstimateAnswer") {
        result.push({
          ...foundConversation.messages[messageIndex - 1],
          Partner: "",
          Type: "",
          Message: costEstimateQuestion,
          File: "",
          Files: [],
        });
      }
      // if (
      //   message.FromUser &&
      //   foundConversation.messages[messageIndex - 1]?.FromUser &&
      //   message.Type === foundConversation.messages[messageIndex - 1]?.Type
      // ) {
      //   message.Type = "";
      // }
      result.push(message);
      if (
        message.FromUser &&
        message.Type === "costEstimateAnswer" &&
        message.Message === "Ja"
      ) {
        // console.log(foundConversation.messages[messageIndex - 1]);
        result.push({
          ...foundConversation.messages[messageIndex - 1],
          Partner: "",
          Type: "",
          Message:
            "Der Patientenservice von Quality Smile wird Sie in Kürze kontaktieren.",
          File: "",
          Files: [],
          Date: foundConversation.messages[messageIndex].Date,
        });
      }
    }
    // result = foundConversation.messages;
  }
  return result;
});

const lastRelevantPartnerMessageType = computed(() => {
  let result = "";
  for (const message of messages.value.slice().reverse()) {
    if (message.FromUser && message.Type !== "general") {
      break;
    } else if (message.Partner) {
      result = message.Type;
      break;
    }
  }
  return result;
});

const contentRef = ref(null);
const scrollToBottom = () => {
  setTimeout(() => {
    contentRef.value?.$el.scrollToBottom();
  }, 500);
};

const allFilesForCase = ref(null);
const { getMessages, messageTypeMapping, getMessageFile } = useMessage();
const isFormClosed = ref(false);
onIonViewDidEnter(async () => {
  isFormClosed.value = false;
  // if (store.state.conversations.length === 0) {
  // if (
  //   store.state.conversations.length === 0 ||
  //   lastRelevantPartnerMessageType.value === "costTakeoverAccept"
  // ) {
  // store.commit("setShowLoading", true);
  // }
  if (messages.value.length === 0) {
    store.commit("setShowLoading", true);
    apiGetCases();
    await getMessages();
  }
  nextTick(async () => {
    const foundUnreadPartnerMessage = messages.value.find(
      (message) => message.Partner && !message.Read
    );
    // if (messages.value.at(-1) && !messages.value.at(-1).Read) {
    if (foundUnreadPartnerMessage) {
      store.commit("setShowLoading", true);
      axios.post("?Mode=General&Function=SetMessagesStatusRead", {
        Id: route.params.caseId,
      });
    }
    if (lastRelevantPartnerMessageType.value === "costTakeoverAccept") {
      store.commit("setShowLoading", true);
      const allFilesForCaseResponse = await axios.post(
        "?Mode=General&Function=GetAllFilesForCase",
        {
          Id: route.params.caseId,
        }
      );
      allFilesForCase.value = allFilesForCaseResponse.data.Result;
      scrollToBottom();
    }
  });
  // }
});

watch(
  messages,
  (newMessages) => {
    if (newMessages.length) {
      scrollToBottom();
    }
  },
  { immediate: true }
);

const userFiles = ref([]);
const partnerFiles = ref([]);
const openBefundeAuswahlModal = async () => {
  const modal = await modalController.create({
    component: BefundeAuswahlModal,
    componentProps: {
      userFiles: userFiles.value,
      partnerFiles: partnerFiles.value,
    },
  });
  modal.onDidDismiss().then((result) => {
    if (result.data?.userFiles) {
      userFiles.value = result.data.userFiles;
    }
    if (result.data?.partnerFiles) {
      partnerFiles.value = result.data.partnerFiles;
    }
  });
  return modal.present();
};

const message = ref("");
const sendMessageToPartner = async (type = "general") => {
  store.commit("setShowLoading", true);
  let requestMessage = message.value;
  if (type === "costEstimateAnswer") {
    // requestMessage = `${costEstimateQuestion} ${message.value}`;
    requestMessage = `${message.value}`;
  }
  const response = await apiSendMessageToPartner(
    route.params.caseId,
    type,
    requestMessage,
    null,
    [...userFiles.value, ...partnerFiles.value]
  );
  if (response.data.Status === "Success") {
    message.value = "";
    userFiles.value = [];
    partnerFiles.value = [];
    store.commit("setShowLoading", true);
    await getMessages();
  }
};

const isPrivacyPersonalDataChecked = ref(false);
const router = useRouter();
const openEndModal = async (routing, isCheckSaved) => {
  const modal = await modalController.create({
    component: EndModal,
    componentProps: {
      routing: routing,
      isCheckSaved: isCheckSaved,
    },
  });
  modal.onDidDismiss().then(() => {
    if (routing === "cancelMessage") {
      router.push({ name: "home" });
    }
  });
  return modal.present();
};
const openShareModal = async () => {
  const modal = await modalController.create({
    component: ShareModal,
    componentProps: {
      routing: allFilesForCase.value.ToPartner,
      routingText: allFilesForCase.value.ToPartner,
      forceAllPrivacies: true,
      caseId: route.params.caseId,
    },
  });
  modal.onDidDismiss().then(async (result) => {
    if (result.data?.submit == "ja") {
      message.value = `Kontaktdaten und die mit dem Anliegen verbundenen Informationen wurden ${allFilesForCase.value.ToPartner} bereitgestellt.`;
      await sendMessageToPartner("costTakeoverAcceptAnswer");
      openEndModal(allFilesForCase.value.ToPartner, result.data?.isCheckSaved);
    }
  });
  return modal.present();
};
</script>

<template>
  <ion-page>
    <ion-header class="ion-no-border">
      <ion-toolbar class="-not-fixed">
        <ion-buttons slot="start">
          <back-button
            :defaultHref="{ name: 'nachrichten' }"
            :icon="require('@lib/assets/icons/icon_zurueck.svg')"
            text=""
          >
          </back-button>
        </ion-buttons>
        <ion-title>Nachrichten</ion-title>
        <ion-button
          @click="store.commit('setOpenMenu', true)"
          slot="end"
          fill="clear"
          size="large"
          ><ion-icon
            slot="icon-only"
            :src="require('@lib/assets/icons/menu.svg')"
            size="large"
          ></ion-icon
        ></ion-button>
      </ion-toolbar>
      <!-- <ion-toolbar class="-not-fixed"> -->
      <div
        class="ion-padding-horizontal"
        style="
          color: var(--ion-color-primary);
          background: white;
          padding-bottom: 16px;
        "
      >
        <b>{{ store.getters.casesById[route.params.caseId]?.PartnerId }}</b>
        <!-- <div>Betreff: {{ messageTypeMapping[messages[0]?.Type] }}</div> -->
      </div>
      <!-- </ion-toolbar> -->
    </ion-header>
    <ion-content fullscreen class="ion-padding" ref="contentRef">
      <ion-grid>
        <!-- <ion-list lines="none"> -->
        <template
          v-for="(message, messageIndex) of messages"
          :key="message.MessageId"
        >
          <div
            class="ion-text-center ion-margin-vertical"
            v-if="
              message.Date.substring(0, 10) !==
              messages[messageIndex - 1]?.Date.substring(0, 10)
            "
          >
            <!-- <ion-chip disabled color="dark">
              <ion-label>
                {{
                  DateFormatter.formatDate(new Date(message.Date), "DD.MM.YYYY")
                }}
              </ion-label>
            </ion-chip> -->
            <div class="c-date">
              {{
                DateFormatter.formatDate(new Date(message.Date), "DD.MM.YYYY")
              }}
            </div>
          </div>
          <div
            class="c-message ion-margin-top"
            :class="{
              '-user': message.FromUser,
              '-partner': message.Partner !== undefined,
            }"
          >
            <ion-label class="ion-text-wrap">
              <div class="c-message__text">
                <b v-if="message.Partner">
                  {{ message.Partner }}
                </b>
                <div v-if="messageTypeMapping[message.Type]">
                  Service: {{ messageTypeMapping[message.Type] }}
                </div>
                <!-- <p>
                {{
                  DateFormatter.formatDate(
                    new Date(message.Date),
                    "DD.MM.YYYY HH:mm"
                  )
                }}
              </p> -->
                <div style="margin-top: 8px">{{ message.Message }}</div>
              </div>
              <div class="ion-margin-top ion-margin-end">
                <template v-if="message.Files">
                  <ion-button
                    v-for="file of message.Files"
                    :key="file.Id"
                    class="ion-text-wrap"
                    style="
                      height: auto;
                      max-width: 100%;
                      overflow-wrap: anywhere;
                    "
                    fill="clear"
                    @click="downloadFile(file.Id, file.Name, file.MimeType)"
                  >
                    {{ file.Name }}
                    <ion-icon
                      slot="end"
                      :icon="arrowDownCircleOutline"
                    ></ion-icon>
                  </ion-button>
                </template>
                <ion-button
                  class="ion-text-wrap"
                  style="height: auto; max-width: 100%; overflow-wrap: anywhere"
                  fill="clear"
                  v-if="message.File"
                  @click="getMessageFile(message.MessageId, message.File)"
                >
                  {{ message.File }}
                  <ion-icon
                    slot="end"
                    :icon="arrowDownCircleOutline"
                  ></ion-icon>
                </ion-button>
              </div>
              <div class="c-message__time">
                {{ DateFormatter.formatDate(new Date(message.Date), "HH:mm") }}
              </div>
            </ion-label>
          </div>
        </template>
        <!-- </ion-list> -->
      </ion-grid>
    </ion-content>

    <ion-footer>
      <ion-toolbar>
        <template v-if="lastRelevantPartnerMessageType === 'costEstimate'">
          <div class="ion-padding">
            <ion-list lines="none" class="ion-no-padding">
              <ion-radio-group v-model="message">
                <div>{{ costEstimateQuestion }}</div>
                <ion-item>
                  <ion-label color="primary">Ja</ion-label>
                  <ion-radio slot="start" value="Ja"></ion-radio>
                </ion-item>
                <ion-item>
                  <ion-label color="primary">Nein</ion-label>
                  <ion-radio slot="start" value="Nein"></ion-radio>
                </ion-item>
              </ion-radio-group>
            </ion-list>
            <div class="ion-text-center">
              <ion-button
                :disabled="!message"
                class="ion-margin-top"
                fill="outline"
                @click="sendMessageToPartner('costEstimateAnswer')"
                >Absenden</ion-button
              >
            </div>
          </div>
        </template>
        <template
          v-else-if="
            lastRelevantPartnerMessageType === 'costTakeoverAccept' &&
            allFilesForCase &&
            !isFormClosed
          "
        >
          <ion-button
            class="ion-float-right"
            fill="clear"
            @click="isFormClosed = true"
            ><ion-icon :icon="close" slot="icon-only"></ion-icon
          ></ion-button>
          <div class="ion-padding">
            <h2>Unterstützung von {{ allFilesForCase.ToPartner }}</h2>
            <p>
              Damit das Patientenservice von {{ allFilesForCase.ToPartner }} Sie
              bei der Suche nach einem geeigneten Zahnlabor bestmöglich
              unterstützen kann, können Sie {{ allFilesForCase.ToPartner }} Ihre
              Kontaktdaten und die mit Ihrem Anliegen verbundenen Informationen
              bereitstellen:
            </p>
            <ul>
              <li v-if="allFilesForCase.Check">RoodieCheck.pdf</li>
              <li
                v-for="checkFile of allFilesForCase.CheckFiles"
                :key="checkFile.Id"
              >
                {{ checkFile.Name }}
              </li>
              <li
                v-for="messageFile of allFilesForCase.Messages"
                :key="messageFile.MessageId"
              >
                {{ messageFile.File }}
              </li>
            </ul>
            <PrivacyPersonalData
              v-model="isPrivacyPersonalDataChecked"
              :routing="allFilesForCase.ToPartner"
            ></PrivacyPersonalData>
            <div class="ion-text-right ion-margin-top">
              <ion-button fill="clear" @click="openEndModal('cancelMessage')"
                >Suche beenden</ion-button
              >
              <ion-button
                :disabled="!isPrivacyPersonalDataChecked"
                @click="openShareModal()"
                >Weiter</ion-button
              >
            </div>
          </div>
        </template>
        <template v-else>
          <ion-button
            fill="clear"
            slot="start"
            @click="openBefundeAuswahlModal()"
            class="ion-no-margin"
          >
            <ion-icon :icon="attach" slot="icon-only"></ion-icon>
            <!-- <div
              v-if="userFiles.length + partnerFiles.length"
              class="c-badge"
              style="position: absolute; top: 0; right: -6px">
              {{ userFiles.length + partnerFiles.length }}
            </div> -->
          </ion-button>
          <!-- <ion-item lines="none"> -->
          <div>
            <ion-textarea
              class="ion-no-margin"
              placeholder="Nachricht verfassen..."
              :rows="1"
              auto-grow
              v-model="message"
              autocapitalize="on"
            ></ion-textarea>
          </div>
          <!-- </ion-item> -->
          <ion-button
            fill="clear"
            slot="end"
            @click="
              sendMessageToPartner(
                messages.at(-1)?.Type === 'participationPolicyMedicalContact'
                  ? 'participationPolicyMedicalContactAnswer'
                  : 'general'
              )
            "
            class="ion-no-margin"
            ><ion-icon :icon="sendOutline" slot="icon-only"></ion-icon
          ></ion-button>
        </template>
      </ion-toolbar>
      <ion-toolbar v-if="userFiles.length + partnerFiles.length">
        <ion-row class="ion-align-items-center ion-justify-content-center">
          <ion-col size="auto">
            {{ userFiles.length + partnerFiles.length }}
            {{
              userFiles.length + partnerFiles.length === 1
                ? "Dokument"
                : "Dokumente"
            }}
            ausgewählt
          </ion-col>
          <ion-col size="auto">
            <ion-button
              fill="clear"
              size="small"
              @click="
                userFiles = [];
                partnerFiles = [];
              "
              ><ion-icon slot="icon-only" :icon="trashOutline"></ion-icon
            ></ion-button>
          </ion-col>
        </ion-row>
      </ion-toolbar>
    </ion-footer>
  </ion-page>
</template>

<style scoped lang="scss">
ion-footer {
  max-height: 50vh;
  overflow-y: auto;
  border-top: 1px solid var(--ion-color-medium);
}
.c-date {
  // border: 1px solid black;
  display: inline-block;
  border-radius: 20px;
  padding: 4px 12px;
  background: var(--ion-color-medium);
  color: var(--ion-color-dark);
}
.c-message {
  border-radius: 16px;
  position: relative;
  padding: 20px 0;

  &__text {
    padding: 0 16px;
    white-space: pre-line;
  }

  &__time {
    position: absolute;
    bottom: 2px;
    right: 10px;
    color: var(--ion-color-dark-tint);
    font-size: small;
  }

  &.-partner {
    background: var(--ion-color-medium);
    --background: var(--ion-color-medium);
    margin-right: 32px;
    border-top-left-radius: 0;

    &:after {
      content: " ";
      position: absolute;
      width: 0;
      height: 0;
      left: -10px;
      right: auto;
      top: 0px;
      bottom: auto;
      border: 22px solid;
      border-color: var(--ion-color-medium) transparent transparent transparent;
    }
  }

  &.-user {
    background: var(--gangl-color-purple);
    --background: var(--gangl-color-purple);
    margin-left: 32px;
    border-top-right-radius: 0;

    &:after {
      content: " ";
      position: absolute;
      width: 0;
      height: 0;
      left: auto;
      right: -10px;
      top: 0px;
      bottom: auto;
      border: 22px solid;
      border-color: var(--gangl-color-purple) transparent transparent
        transparent;
    }
  }
}
</style>
